import {useGetStudioMode} from "components/Layout/hooks";
import Menu from "./Menu";
import Interaction from "./Interaction";
import Develop from "./Develop";
import styles from "./index.module.scss";
import {memo} from "react";

export default memo(function Header({
  handleObjectPanel,
  isPropertyPanelOpen,
  isObjectPanelOpen,
  handlePropertyPanel,
  isCodeMode,
  handleCodeMode,
}) {
  const {isEditMode} = useGetStudioMode();
  return (
    <header className={styles.container}>
      <Menu
        handleObjectPanel={handleObjectPanel}
        isObjectPanelOpen={isObjectPanelOpen}
        isEditMode={isEditMode}
        isCodeMode={isCodeMode}
        handleCodeMode={handleCodeMode}
      />
      {isEditMode && <Interaction />}
      <Develop isPropertyPanelOpen={isPropertyPanelOpen} handlePropertyPanel={handlePropertyPanel} isEditMode={isEditMode} />
    </header>
  );
});
